/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type TypeActe from '@/types/TypeActe';

export const TYPE_ACTE_OPTIONS: Array<{
  key: string;
  text: string;
  value: TypeActe;
}> = [
  { key: 'naissance', text: 'Acte de naissance', value: 'naissance' },
  {
    key: 'reconnaissance',
    text: 'Acte de reconnaissance',
    value: 'reconnaissance',
  },
  { key: 'mariage', text: 'Acte de mariage', value: 'mariage' },
  { key: 'deces', text: 'Acte de décès', value: 'deces' },
  { key: 'pacs', text: 'PACS', value: 'pacs' },
  { key: 'decision', text: 'Décision', value: 'decision' },
];

export const SOUS_TYPE_ACTE_OPTIONS: Record<TypeActe, Array<object>> = {
  naissance: [
    {
      key: 'declaration-naissance',
      text: 'Déclaration de naissance',
      value: 'N',
    },
    {
      key: 'declaration-naissance-nom',
      text: 'Déclaration de naissance avec choix de nom',
      value: 'DCN',
    },
    {
      key: 'declaration-changement-nom',
      text: 'Déclaration de changement de nom',
      value: 'ACN',
    },
    {
      key: 'transcription-naissance',
      text: 'Transcription de jugement déclaratif de naissance',
      value: 'JDN',
    },
    {
      key: 'transcription-adoption',
      text: "Transcription de jugement d'adoption plénière",
      value: 'JAP',
    },
    {
      key: 'proces-verbal',
      text: "Procès-verbal d'enfant trouvé",
      value: 'PVET',
    },
    { key: 'acte-provisoire', text: 'Acte provisoire', value: 'P' },
  ],
  reconnaissance: [
    { key: 'avant-naissance', text: 'Avant la naissance', value: 'N' },
    { key: 'pendant-vie', text: 'Pendant la vie', value: 'V' },
    { key: 'apres-deces', text: 'Après le décès', value: 'D' },
  ],
  mariage: [
    { key: 'projet-mariage', text: 'Projet de mariage', value: 'P' },
    { key: 'acte-mariage', text: 'Acte de mariage', value: 'M' },
    {
      key: 'acte-opposition',
      text: "Acte d'opposition au mariage",
      value: 'O',
    },
    { key: 'acte-reprise', text: 'Acte de reprise de vie commune', value: 'R' },
    {
      key: 'transcription-acte',
      text: "Transcription d'acte de mariage",
      value: 'T',
    },
  ],
  deces: [
    { key: 'deces', text: 'Décès', value: 'D' },
    { key: 'transcription', text: 'Transcription', value: 'T' },
    { key: 'enfant-sans-vie', text: 'Enfant sans vie', value: 'ESV' },
    {
      key: 'jugement-absence',
      text: "Jugement déclaratif d'absence",
      value: 'JDA',
    },
    {
      key: 'jugement-deces',
      text: 'Jugement déclaratif de décès',
      value: 'JDD',
    },
  ],
  pacs: [],
  decision: [
    { key: 'dcp', text: 'Décision de changement de prénom', value: 'DCP' },
    {
      key: 'dcnet',
      text: 'Décision de changement de nom (mise en concordance avec un acte étranger)',
      value: 'DCNET',
    },
    {
      key: 'dcnf',
      text: 'Décision de changement de nom (loi 2022-301)',
      value: 'DCNF',
    },
  ],
};

/**
 * Mapping TypeActe → valeur tableacte stockée en base (champ ai_tableacte de ec_acte_individu)
 */
export const TABLE_ACTE_BY_TYPE: Record<TypeActe, string> = {
  naissance: 'EC_ACTN',
  mariage: 'EC_ACTM',
  deces: 'EC_ACTD',
  reconnaissance: 'EC_ACTR',
  pacs: 'EC_CONVENTION_DECLARATION',
  decision: 'EC_ACTN',
};
